import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import "../src/assets/style/main.scss"
import VueCookies from 'vue-cookies';
import VeeValidate from 'vee-validate';
import VueGtag from "vue-gtag";
import AppEventBus from './appEventBus';


//FILES
import "./assets/ImpactHQPrivacyPolicy.pdf";



import TrainingService from './services/trainingService';
import IndustryNewsService from './services/industryNewsService';
import GrantsService from './services/grantsService';
import LeadershipProgramService from './services/leadershipProgramService';
import FunderService from './services/funderService';
import GrantFormService from './services/grantFormService';
import GrantReportFormService from './services/grantReportFormService';
import UserService from './services/userService';
import OrganizationService from './services/organizationService';
import newImpactService from './services/newImpactService';
import contactService from './services/contactService';
import contentResourceService from './services/contentResourceService';
import singleTypeService from './services/singleTypeService';
import ChoiceService from './services/choiceService'
import ResourceService from './services/resourceService'
import ResourceFormService from './services/resourceFormService'
import ApplicationService from './services/applicationService';
import SurveySubmissionService from './services/surveySubmissionService';
import SurveyConfigurationService from './services/surveyConfigurationService';
import { getFileUrl } from './utils/urlHelper';

import axios from 'axios';
import VueAxios from 'vue-axios';
import Pagination from 'vue-pagination-2';

Vue.config.productionTip = false

Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(TrainingService);
Vue.use(IndustryNewsService);
Vue.use(GrantsService);
Vue.use(LeadershipProgramService);
Vue.use(FunderService);
Vue.use(GrantFormService);
Vue.use(GrantReportFormService);
Vue.use(UserService);
Vue.use(OrganizationService);
Vue.use(newImpactService);
Vue.use(contactService);
Vue.use(contentResourceService);
Vue.use(singleTypeService);
Vue.use(ChoiceService);
Vue.use(ResourceService);
Vue.use(ResourceFormService);
Vue.use(ApplicationService);
Vue.use(SurveySubmissionService);
Vue.use(SurveyConfigurationService);
Vue.use(VeeValidate, {
  events: '',
});
Vue.use(VueGtag, {
  config: { id: 'G-26SR98W329' }
}, router);
Vue.use(AppEventBus);
Vue.component('pagination', Pagination);

VeeValidate.Validator.extend('verify_password', {
  getMessage: () => 'The password must be a minimum of 8 characters long contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ! etc)',
  validate: value => {
    let strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\.\,])(?=.{8,})');
    return strongRegex.test(value);
  }
});

Vue.filter('toCurrency', function (value) {
  const numericValue = Number(value);
  if (isNaN(numericValue)) {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });

  return formatter.format(numericValue);
});

// Global filter for file URLs
Vue.filter('fileUrl', getFileUrl);

// Global method for file URLs
Vue.prototype.$getFileUrl = getFileUrl;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
